import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SalesSummaryPage } from '@/features/sales-reports/pages/sales-summary-page';

export const Route = createFileRoute('/_app/sales-summary')({
  validateSearch: z.object({
    grain: z.enum(['day', 'month', 'year']).optional().catch(undefined),
    period: z
      .string()
      .regex(/^\d{4}(-\d{2}(-\d{2})?)?$/)
      .optional()
      .catch(undefined),
    branch: z.string().uuid().optional().catch(undefined),
    /** which earlier range the page is set against; the previous period unless asked */
    cmp: z.enum(['previous', 'lastYear']).optional().catch(undefined),
  }),
  component: SalesSummaryPage,
});
